import { Navigate, Outlet } from 'react-router-dom';

type Props = {
    /** Retorna true se o usuário pode acessar as rotas filhas. */
    check: () => boolean;
    fallback?: React.ReactNode;
};

/**
 * Gate de rota por permissão/flag (ex.: ViewAny:StockConsult).
 */
export default function RequireCan({ check, fallback }: Props) {
    if (!check()) {
        return fallback ? <>{fallback}</> : <Navigate to="/forbidden" replace />;
    }

    return <Outlet />;
}
